import React from 'react'

export default function Loader({ location = null }) {
    return (
        <div className="Loader column is-vcentered">
            <div className="spinner-container container">
                <div className="spinner"></div>
                <p className="subtitle is-4">Loading {location || '...'}</p>
            </div>
        </div>
    )
}
